<template>
  <NotificationComponent
    v-show="visible"
    :title="notificationtitle"
    @close="handleCloseNotification"
  >
    <div
      v-if="hasErrors"
      class="text-left"
    >
      <p class="mb-2 text-sm font-normal text-steel-800">
        The following issues occured:
      </p>
      <div
        v-for="[fieldName, errors] in errorEntries"
        :key="fieldName"
        class="mb-2"
      >
        <p class="text-sm font-semibold capitalize text-steel-800">
          {{ formatFieldName(fieldName) }}:
        </p>
        <p
          v-for="(error, errorIndex) in errors"
          :key="errorIndex"
          class="ml-4 text-sm font-normal text-steel-700"
        >
          {{ error }}
        </p>
      </div>

      <span
        class="ml-auto mr-2 flex w-max cursor-pointer text-sm text-sun-700 underline"
        @click="handleRetry"
      >
        Retry
      </span>
    </div>

    <div
      v-else
      class="flex flex-col gap-2 text-left"
    >
      <p
        v-if="type === 'success'"
        class="text-sm text-steel-1100"
      >
        {{ subText || "You've successfully booked this load." }}
      </p>
      <p
        v-else
        class="text-sm text-steel-1100"
      >
        Please check other loads or contact the broker for more options.
      </p>
    </div>
  </NotificationComponent>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { NotificationComponent } from '@/components';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'success',
    validator: (v) => ['success', 'error'].includes(v),
  },
  title: {
    type: String,
  },
  subText: {
    type: String,
  },
});

const store = useStore();

const notificationtitle = computed(() =>
  props?.title
    ? props?.title
    : props.type === 'success'
      ? 'Load Booked'
      : 'This load is no longer available to book.'
);

const errorMessage = computed(() => store.state.loads?.book_load_error);

const hasErrors = computed(() => {
  const error = errorMessage.value;
  return error && typeof error === 'object' && Object.keys(error).length > 0;
});

const errorEntries = computed(() => {
  if (!errorMessage.value || typeof errorMessage.value !== 'object') {
    return [];
  }
  return Object.entries(errorMessage.value);
});

const formatFieldName = (fieldName) => {
  return fieldName
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const handleCloseNotification = () => {
  store.dispatch('toast/clearToasts');
};

const handleRetry = () => {
  store.dispatch('toast/clearToasts');
};
</script>
